module.exports = __webpack_public_path__ + "img/BlinkArt_Sword7_Green.efb3a00c.png";